import { Component, OnInit } from '@angular/core';
import Swal from 'sweetalert2';
import { AuthServiceService } from '../../shareModule/services/auth-service.service';
import { ToastrService } from 'ngx-toastr';
import { LocalServiceService } from '../../shareModule/services/local-service.service';
import { Router, ActivatedRoute } from '@angular/router';
import {
  NgbModal,
  ModalDismissReasons,
  NgbModalOptions,
} from '@ng-bootstrap/ng-bootstrap';
import { CustomerService } from 'src/app/shareModule/services/customer.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-new-dashboard',
  templateUrl: './new-dashboard.component.html',
  styleUrls: ['./new-dashboard.component.scss'],
})
export class NewDashboardComponent implements OnInit {
  id: any;
  transactions: any;
  total_txn: number = 0;
  ending: number = -1;

  referralUsers: any = {
    data: [],
    totalItems: 0,
    totalPages: 0,
    currentPage: 0,
  };
  supports: any = []
  carouselOptionsLogos: any = {
    slidesPerView: 1,
    spaceBetween: 10,
    breakpoints: {
      0: {
        slidesPerView: 3,
      },
      1024: {
        slidesPerView: 4,
      },
      1200: {
        slidesPerView: 7,
      },
    },
  };
  imgUrl = environment.ImageUrl;
  brands: any = [];
  dropdownPrice: boolean = false;
  dashboard: any = {
    supporters: 0,
    same_region: 0,
    user_signup: 0
  };
  constructor(
    private auth: AuthServiceService,
    private toastr: ToastrService,
    private local: LocalServiceService,
    private route: ActivatedRoute,
    private router: Router,
    private modalService: NgbModal,
    private customerService: CustomerService
  ) {

  }

  private openWelcomeMessage() {
    console.log('showing welcome message')

    const html = `
       <div class='d-flex flex-column justify-content-center align-items-center'>
          <span class='fa fa-star' style='color: yellow; font-size: 3rem'></span>
          <p style='font-size: 2rem; font-weight: bold;' class='mt-3'>Welcome to Kachiing!</p>
         
       </div>
    `;
    Swal.fire({
      html: html,
      confirmButtonText: '<i class="fa fa-thumbs-up"></i> Ok!'
    })

  }

  showSupports() {
    this.modalService.dismissAll();
    this.auth.getMySupports().subscribe({
      next: (data) => {
        if (!data.ok) {
          this.toastr.error('Error something went wrong');
          return;
        }
        //console.log(data.data, "BROOO")

        this.supports = data.data

        // const instance = this.modalService.open(SupportListComponent, {
        //   size: 'sm',
        //   windowClass: 'supports-modal',
        // });
        // instance.componentInstance.supports = data.data;
      },
      error: (err) => {
        console.error(err);
        this.toastr.error('Error something went wrong');
      },
    });
  }

  referrals: any = []
  showReferrals(referral: any, modal: any) {
    this.auth.getUsersByReferralId({ referralId: referral.id })
      .subscribe((resp) => {
        this.referrals = resp.body
        this.view_all_transactions(modal)
      })
  }


  ngOnInit(): void {
    let { id } = this.local.getUser();
    this.id = id;

    this.vip_token_transactions();
    this.getReferralUsers();
    this.getBrands();
    this.getDashboardSubAdmin();
    this.showSupports()

    if (this.local.getUser()?.isFirstLogin) {
      setTimeout(() => {
        this.openWelcomeMessage();
        this.local.saveLoginUserData({ ...this.local.getUser(), isFirstLogin: false });

      }, 0)


    }


    this.route.queryParams.subscribe((res: any) => {
      if (res.hasOwnProperty('status')) {
        if (res.status == 'success') {
          Swal.fire(
            'Done',
            'Payment done successfully. Credits are added to your account.',
            'success'
          ).then(() => {
            window.location.href = window.location.href.split('?')[0];
          });
        }

        if (res.status == 'sub-success') {
          Swal.fire(
            'Done',
            'Subscription was created successfully.',
            'success'
          ).then(() => {
            window.location.href = window.location.href.split('?')[0];
          });
        }

        if (res.status == 'cancelled') {
          Swal.fire(
            'Cancelled',
            'Payment is cancelled or some error has occured during the payment.',
            'error'
          ).then(() => {
            window.location.href = window.location.href.split('?')[0];
          });
        }

        if (res.status == 'blocked') {
          Swal.fire({
            title: 'Account Blocked',
            text: 'Your account has been blocked by the admin.',
            icon: 'warning',
            confirmButtonColor: '#141631',
            confirmButtonText: 'OK',
            allowOutsideClick: false,
          }).then(() => {
            window.location.reload();
          });
          this.local.logout();
        }
      }
    });
  }

  copyAllEmails() {
    const allEmails = Array.from(
      this.supports.map((support) => support?.appUser?.memberEmails[0]?.email ?? "")
    ).join(',');
    this.copyString(allEmails);
  }
  async copyString(s: string) {
    try {
      await navigator.clipboard.writeText(s);
      this.toastr.success('Copied to clipboard 😄');
      console.log('successfully copied');
    } catch (e) {
      console.error(e);
      this.toastr.error('Error could not copy');
    }
  }

  getBrands() {
    this.auth.brands_fetch().subscribe((response: any) => {
      this.brands = response.body;
    });
  }

  getDashboardSubAdmin() {
    this.auth.getDashboardSubAdmin().subscribe((response: any) => {
      this.dashboard = response.body;
    });
  }

  getReferralUsers(page: number = 1, limit: number = 10) {
    this.customerService
      .getReferralUsers(page, limit)
      .subscribe((response: any) => {
        this.referralUsers = response.body;
      });
  }

  vip_token_transactions() {
    this.auth.vip_token_transactions().subscribe(
      (response: any) => {
        this.transactions = response.body.transactions;
        this.total_txn = response.body.available;
        this.ending = response.body.ending;
      },
      (error) => {
        if (error.status == 401) {
          this.local.logout();
          this.router.navigate(['/admin']);
        }
      }
    );
  }

  view_all_transactions(modal) {
    this.modalService.open(modal, {
      size: 'md',
      ariaLabelledBy: 'modal-basic-title',
    });
  }

  managesubscription(sub_type) {
    let formData = new FormData();
    formData.append('id', this.id);
    formData.append('stripe_price_id', 'xxx');
    formData.append('tokens', 'xxx');
    formData.append('notification_code', 'xxx');
    formData.append('sub_type', sub_type);

    this.auth.create_stripe_checkout_url(formData).subscribe(
      (response: any) => {
        window.location.href = response.body.url;
      },
      (e) => {
        if (e.status == 400) {
          this.toastr.error(e.error.message);
        }
      }
    );
  }
}
